import { CtaBlockComponent } from './CtaBlockComponent';

export function CtaBlockComponentC(
  props: React.ComponentProps<typeof CtaBlockComponent>,
) {
  return <CtaBlockComponent {...props} />;
}
